export class AuthMetaData {
  partner: string;
  entityIdForAdminView: string;
  hint: string;
}
